/**
 * Locales where the OneTrust cookie banner must not be loaded.
 *
 * Single source of truth: imported by the nuxt.config.ts head script (build time),
 * useOneTrustCookies.ts, useUserCookieConsent.ts and plugins/contentsquare.ts. Keep this
 * file dependency-free so it can be evaluated while the Nuxt config is being loaded.
 */
export const notLoadCookieBanner = [
  'en-au',
  'fr-be',
  'en-ca',
  'es-cl',
  'en-hk',
  'en-id',
  'en-il',
  'ja-jp',
  'ko-kr',
  'es-mx',
  'en-my',
  'en-nz',
  'en-ph',
  'en-sg',
  'en-th',
  'en-tr',
  'en-tw',
  'en-ua',
  'en-wx',
  'en-za',
]
